export var DEFAULT_ROUTE_ROOT = "/";